export class ModulPreis {
  preisName = "";
  preis = 0;
  preisNachSteuerJaehrlich = 0;
  preisVorSteuerGemZahlungsweise = 0;
  preisVorSteuerJaehrlich = 0;
  steuerBetrag = 0;
  steuersatz = 0;
  //klauseln: Klausel[];
  modulPmId = "";
  modulBausteinId = "";
  manuellBerechneterPreis = false;
}
